var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('RegisterPitch'),_c('TournamentInfo'),_c('TournamentSwiper',{attrs:{"tournaments":this.tournaments.upcoming,"useBackground":true}}),_c('TournamentSwiper',{attrs:{"tournaments":this.tournaments.past,"useBackground":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }